import { useAppContext } from 'src/components/app-context';
import { CardContent } from '@prisjakt/ui/card';
import { Alignment, Popover } from '@prisjakt/ui/popover';
import { BodySmallText } from '@prisjakt/ui/text/variants';
import React, { useId, useState } from 'react';
import { useIsKWLP } from 'src/areas/keyword-landing-page/contexts';
import styled from 'styled-components';
import type { BaseProps } from '../../types';
import { ClickOutButton } from '../click-out-button';
import { NewClickOutButton } from '../new-click-out-button';
import { layout } from 'src/components/base';

type Props = Pick<BaseProps, 'link' | 'onClick' | 'store'>;
export const GridCardOfferFooter: React.FC<Props> = props => {
  const { store, link, onClick } = props;
  const { t } = useAppContext();
  const [showPopover, setShowPopover] = useState(false);
  const uid = useId();
  const isKWLP = useIsKWLP();
  const disabled = !onClick || !link;

  const handleClick = () => {
    if (disabled) {
      setShowPopover(true);
    }

    if (onClick) {
      onClick();
    }
  };

  return (
    <>
      <FooterContent isKWLP={isKWLP}>
        {isKWLP ? (
          <NewClickOutButton
            href={link || ''}
            onClick={handleClick}
            external
            text={t('product', 'kwlp.visit-shop')}
          />
        ) : (
          <ClickOutButton
            containerProps={{ 'aria-describedby': `offer-${uid}` }}
            store={store}
            href={link || ''}
            onClick={handleClick}
            featured={store && store.featured}
          />
        )}
      </FooterContent>

      {disabled && (
        <Popover
          id={`offer-${uid}`}
          visible={showPopover}
          width={250}
          offsetY={0}
          offsetX={0}
          verticalAlign={Alignment.End}
          horizontalAlign={Alignment.Center}
          onClose={() => setShowPopover(false)}
          zIndex={20}
        >
          <BodySmallText>
            {t('product', 'transparency.store-info')}
          </BodySmallText>
        </Popover>
      )}
    </>
  );
};

const FooterContent = styled(CardContent)<{
  isKWLP?: boolean;
}>`
  && {
    justify-self: flex-end;
    flex: 0;
    ${p => (p.isKWLP ? 'padding-top' : 'padding')}: 0;
    gap: ${layout.measurements.spacing025};
  }
`;
